import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, Injector } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from '../../../../../../services/master.service'
import { MessageService } from '../../../../../../services/message.service'
import * as languageLibrary from '../../../../../../services/language'
import { token } from '../roles.component';
import { DynamicService } from 'src/app/services/dynamic.service';
import { Contact } from 'src/app/models/contact.model';
import { ListHeader } from 'src/app/models/list-header.model';
import { Relationship } from 'src/app/models/relationship.model';

@Component({
    selector: '[role-businessContact]',
    templateUrl: './role-businessContact.component.html',
    styleUrls: ['./role-businessContact.component.scss'],
    standalone: false
})

export class BusinessContactComponent implements OnInit {

    protected contactId: number = 0

    protected contactRoleId: number = 0

    protected words = languageLibrary.language

    protected language: string = 'EN'

    // table headers
    public headers: ListHeader[] = [
        { name: 'title', param: 'title', view: null, disabled: null },
        { name: 'firstName', param: 'firstName', view: null, disabled: null },
        { name: 'lastName', param: 'lastName', view: null, disabled: null },
        { name: 'phoneNumber', param: 'phoneNumber', view: null, disabled: null },
        { name: 'emailAddress', param: 'emailAddress', view: null, disabled: null },
        { name: 'actions', param: null, view: null, disabled: null }
    ]

    public businessContactList: Relationship[] = []

    public relationshipId: number | null = null

    protected loading: boolean = false

    public viewDetail: boolean = false

    public isContactSelected: boolean = false

    public auxContact: Contact | null = null

    protected dataIn: string;

    // Group of inputs
    public information = new FormGroup({
        fromContactId: new FormControl<number>(0),
        firstName: new FormControl<string | null>(null, [Validators.required]),
        lastName: new FormControl<string | null>(null, [Validators.required]),
        relationship: new FormControl<string>("Business Contact"),
        title: new FormControl<string | null>(null),
        phoneNumber: new FormControl<string | null>(null),
        emailAddress: new FormControl<string | null>(null),
    })

    // get information of inputs
    get firstName() { return this.information.get('firstName') }
    get lastName() { return this.information.get('lastName') }
    get relationship() { return this.information.get('relationship') }
    get phoneNumber() { return this.information.get('phoneNumber') }
    get emailAddress() { return this.information.get('emailAddress') }

    /*
    * functions
    */

    constructor(private master: MasterService, private ms: MessageService, private inject: Injector, private serv: DynamicService) {

    }

    deactivateRole() {
        this.serv.outputFromDynamicComponent({ action: "deactivate", contactRoleId: this.contactRoleId });
    }

    ngOnInit() {
        this.dataIn = this.inject.get(token);
        this.contactId = this.dataIn['contactId']
        this.contactRoleId = this.dataIn['contactRoleId']

        if (!this.contactId) {
            return
        }

        this.readRelationships()
    }

    /** Contact was modified in the modal */ 
    public modified = (e): void => {
        this.readRelationships()
    }

    // todo:get data for contact selected
    public getContactBusinessContactDetail = (relationship: Object, openDetail: boolean) => {
        this.loading = true
        this.master.get(`contacts/${relationship['fromContactId']}`, res => {
            this.loading = false
            this.viewDetail = true

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.auxContact = res.data.contact

            setTimeout(() => {
                const btn = (document.getElementById('editContactModalBtn') as HTMLButtonElement)
                if (btn) {
                    btn.click()
                }
            }, 100)
        })
    }

    // clean Fields
    protected reset = (): void => {
        this.information.reset()
        this.loading = false
    }

    public createContact = (closeAfter) => {
        this.information.get("relationship").setValue("Business Contact")
        this.master.post(`contacts/${this.contactId}/relationships`, this.information.value, res => {
            if (!res) {
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.readRelationships()
            const btn = (document.getElementById('btn-cancel-businessContacts-new') as HTMLButtonElement)
            if (btn && closeAfter) {
                btn.click()
            }
            this.reset()

        })
    }

    /**
    * Update the realtionship identity based on which one was clicked in the UI.
    * @param relationship 
    * @param mode 
    */
    public setBusinessContact(relationship: Object, mode: string | null = null) {
        this.relationshipId = parseInt(relationship['id'])
    }

    // delete businessContact
    public discard = (): void => {
        if (!this.relationshipId || isNaN(this.relationshipId) || (this.relationshipId <= 0)) {
            return
        }

        this.loading = true
        this.master.discard(`contacts/${this.contactId}/relationships/${this.relationshipId}`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.readRelationships()

            let btn = (document.getElementById('close-delete-modal-businessContact') as HTMLButtonElement)
            if (btn) {
                btn.click()
            }

        })
    }

    private readRelationships = (): void => {
        this.master.get(`contacts/${this.contactId}/relationships?relationship=Business%20Contact`, (res: { status: number; data: { error: any; relationships: []; }; }) => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.businessContactList = res.data.relationships

        })
    }

    filterForCommunication(relationship, searchFor): any[] {
        let relationshipSearchList = relationship.contact.contactCommunications ? relationship.contact.contactCommunications : null
        if (relationshipSearchList.length == 0) { return null }
        return relationshipSearchList.filter(comms => comms.type === searchFor);
    }

    filterForCommunicationModify(relationship, searchFor): any[] {
        let relationshipSearchList = relationship.contact.contactCommunications ? relationship.contact.contactCommunications : null
        if (relationshipSearchList.length == 0) { return null }
        const returnedValue = relationshipSearchList.find(comms => comms.type === searchFor);
        if (typeof returnedValue !== 'undefined') {
            return returnedValue.value
        }
        return null
    }
}
